import { apiCall, apiFile } from '../helpers/axios';

class CatalogService {

	static getMasterCatalog(auctionId, params) {
		return apiCall().post(`/auctions/${auctionId}/catalog/master`, params, {
            responseType: 'blob',
		}).then(response => response.data);
	}

	static getUserCatalog(auctionId, params) {
		return apiCall().post(`/auctions/${auctionId}/catalog/user`, params, {
            responseType: 'blob',
		}).then(response => response.data);
	}

	static getRegisterCatalog(auctionId, params) {
		return apiCall().post(`/auctions/${auctionId}/catalog/register`, params, {
            responseType: 'blob',
		}).then(response => response.data);
	}
}

export default CatalogService


// WEBPACK FOOTER //
// ./src/services/catalog-service.js